module.exports = {
    SERVER_URL: window._env.SERVER_URL,
    API_BASE: window._env.API_BASE,
    WEBSITE_BASE: window._env.WEBSITE_BASE,
    IMG_URL: window._env.IMG_URL,
    STRIPE_PUBLISHABLE_KEY: window._env.STRIPE_PUBLISHABLE_KEY
}
